import type { Language } from '../types/language';

export interface EventType {
  title: Record<Language, string>;
  description: Record<Language, string>;
  detail?: Record<Language, string>;
  note?: Record<Language, string>;
}

export const eventTypes: EventType[] = [
  {
    title: { en: 'Private Classes & Coaching', es: 'Clases privadas y coaching' },
    description: { en: 'Private 1-on-1 classes and personalized coaching for beginners, dancers, couples and performers.', es: 'Clases privadas 1 a 1 y coaching personalizado para principiantes, bailarines, parejas y performers.' },
    detail: { en: 'Salsa · Bachata · Hip Hop · Commercial · Latin Fusion · Partner Work', es: 'Salsa · Bachata · Hip Hop · Commercial · Latin Fusion · Trabajo en pareja' },
  },
  {
    title: { en: 'Weddings & Couples', es: 'Bodas y parejas' },
    description: { en: 'Private lessons and custom choreography for first dances, wedding parties and unforgettable wedding moments.', es: 'Clases privadas y coreografía personalizada para primeros bailes, grupos nupciales y momentos inolvidables.' },
  },
  {
    title: { en: 'Quinceañeras', es: 'Quinceañeras' },
    description: { en: 'Custom choreography, coaching and preparation for quinceañeras, damas, chambelanes and complete performance groups.', es: 'Coreografía, coaching y preparación personalizada para quinceañeras, damas, chambelanes y grupos completos.' },
    note: { en: 'Available completely in Spanish.', es: 'Disponible completamente en español.' },
  },
  {
    title: { en: 'Groups & Competitions', es: 'Grupos y competencias' },
    description: { en: 'Professional coaching and choreography for studios, dance teams, crews, schools and competition groups.', es: 'Coaching y coreografía profesional para estudios, equipos de baile, crews, escuelas y grupos de competencia.' },
    detail: { en: 'Professional performance experience · Competition-winning choreography', es: 'Experiencia profesional en performance · Coreografía ganadora en competencias' },
  },
  {
    title: { en: 'Corporate & Live Events', es: 'Eventos corporativos y en vivo' },
    description: { en: 'Professional dancers, custom performances and live entertainment for corporate events, private celebrations and productions.', es: 'Bailarines profesionales, performances personalizados y entretenimiento en vivo para eventos corporativos, celebraciones privadas y producciones.' },
  },
  {
    title: { en: 'Custom Choreography', es: 'Coreografía personalizada' },
    description: { en: 'Original choreography and creative direction for artists, music videos, stages, competitions, groups and special projects.', es: 'Coreografía original y dirección creativa para artistas, videos musicales, escenarios, competencias, grupos y proyectos especiales.' },
  },
];
